import React from 'react'
import { Logs } from '../../Common/Common'
import dayjs from 'dayjs'
import _ from 'lodash'

export default function LogsPanel ({ logs, date }) {
  return (
    <Logs
      entries={logs}
      title={dayjs(date).format('dddd DD MMMM YYYY')}
    />
  )
}
